document.addEventListener("DOMContentLoaded", function (event) {
  // mage menu

  let megaMenuList1 = document.querySelectorAll('.yg-mega-menu1')

  megaMenuList1.forEach((item) => {
      let megaList = item.querySelectorAll(".mega-menu-list li");
      let megaMenu = item.querySelectorAll(".yg-mega-menu-container");
      let megaLi = item.querySelectorAll(".list-menu-item.yg-mega-menus");
      let activeIndex = 0;
    
      megaList.forEach((item, index) => {
        item.addEventListener("mouseover", function () {
          setActive(index);
        });
      });
      megaLi.forEach((item) => {
        item.addEventListener("mouseover", function () {
          const megaMenu = item.querySelector(".yg-mega-menu-container");
          if (megaMenu) {
            megaMenu.classList.add("active");
          }
        });
      });
    
      function setActive(index) {
        megaMenu.forEach((menu) => menu.classList.remove("active"));
        megaMenu[index].classList.add("active");
        activeIndex = index;
      }
    
      document.addEventListener("mouseleave", function (event) {
        const isHoveringMegaMenu = Array.from(megaMenu).some((menu) =>
          menu.contains(event.relatedTarget),
        );
        const isHoveringMegaList = Array.from(megaList).some((item) =>
          item.contains(event.relatedTarget),
        );
    
        if (!isHoveringMegaMenu && !isHoveringMegaList) {
          setActive(activeIndex);
        }
      });
  })
  
  // mage menu

  // yg mega menu 2

  let megaMenuList2 = document.querySelectorAll('.yg-mega-menu2')

  megaMenuList2.forEach((item) => {
      const megaTab = item.querySelectorAll(".yg-menu-tab");
      const menuContainer = item.querySelectorAll(
        ".yg-mega-menu-list .yg-menu2-li ",
      );
      const menuList2 = item.querySelectorAll(".yg-mega-submenu .mega-menu__submenu-item");
      const megaMenu2 = item.querySelectorAll(".yg-mega-submenu .yg-mega-menu-container");
      let activeIndex2 = 0;
    
      megaTab.forEach((item, index) => {
        item.addEventListener("mouseover", function () {
          setActive2(index);
          megaTab.forEach((menu) => menu.classList.remove("active"));
          item.classList.add("active");
        });
      });
    
      menuList2.forEach((item, index) => {
        item.addEventListener("mouseover", function () {
          menuList2.forEach((menu) => menu.classList.remove("active"));
          item.classList.add("active");
          megaMenu2.forEach((menu) => menu.classList.remove("active"));
          megaMenu2[index].classList.add("active");
        });
      });
    
      function setActive2(index) {
        menuContainer.forEach((menu) => menu.classList.remove("active"));
        menuContainer[index].classList.add("active");
        const submenuLi =  menuContainer[index].querySelector(".yg-mega-submenu .mega-menu__submenu-item");
        const submenu = menuContainer[index].querySelector('.yg-mega-submenu .yg-mega-menu-container');
        if (submenuLi) {
          submenuLi.classList.add("active");
        }
        if (submenu) {
          submenu.classList.add('active');
        }
        activeIndex2 = index;
      }
      })

  // yg mega menu 2

  //  yg-product-points
  let productTab = document.querySelectorAll(".yg-product-points-span");
  let productPoints = document.querySelectorAll(".yg-product-points-link");
  let productBox = document.querySelectorAll(".yg-product-points-tab");
  productTab.forEach((tab, index) => {
    tab.addEventListener("click", (e) => {
      let productBox = tab.parentNode.querySelector(".yg-product-points-link");
      if (productBox.classList.contains("hide")) {
        productBox.classList.remove("hide");
      } else {
        productBox.classList.add("hide");
      }
    });
  });
  productBox.forEach((box) => {
    let dataTop = box.getAttribute("data-top");
    let dataTopMobile = box.getAttribute("data-top-mobile");

    dataTop = parseInt(dataTop, 10);
    dataTopMobile = parseInt(dataTopMobile, 10);

    if (dataTop > 50) {
      box.classList.add("is-bottom");
    }
    if (dataTopMobile > 50) {
      box.classList.add("is-bottom-mobile");
    }
  });

  document.addEventListener("click", function (event) {
    const isClickInsideTab = Array.from(productTab).some((tab) =>
      tab.contains(event.target),
    );
    const isClickInsidePoint = Array.from(productPoints).some((point) =>
      point.contains(event.target),
    );

    if (!isClickInsideTab && !isClickInsidePoint) {
      productPoints.forEach((point) => {
        point.classList.add("hide");
      });
    }
  });
  //  yg-product-points

  // product card
  const productCountry = document.querySelectorAll("[data-product]");
  function updateProductCountry() {
    fetch("https://ipinfo.io/json")
        .then((response) => response.json())
        .then((data) => {
          const country = data.country; // 国家的简称
          console.log(`${country}`);
          productCountry.forEach((element) => {
            const shadow = element.querySelector(".yg-product-overlay");
            if (element.dataset.countryAustralia && country === "AU") {
              element.classList.add("active");
            }
            if (element.dataset.countryUnited_states && country === "US") {
              element.classList.add("active");
            }
            if (element.dataset.countrySingapore && country === "SG") {
              element.classList.add("active");
            }
            if (element.dataset.countryIndia && country === "IN") {
              element.classList.add("active");
            }
            if (element.dataset.countryNigeria && country === "NG") {
              element.classList.add("active");
            }
            if (element.dataset.countryPhilippines && country === "PH") {
              element.classList.add("active");
            }
            if (element.dataset.countryCanada && country === "CA") {
              element.classList.add("active");
            }
            if (element.dataset.countryHong_kong_china && country === "HK") {
              element.classList.add("active");
            }
            if (element.dataset.countryTaiwan_china && country === "TW") {
              element.classList.add("active");
            }
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
  }

  updateProductCountry();
});
